export const nhomKhachHang = {
  sections: { list: { title: '客户分组' } },
  filter: {
    searchPlaceholder: '按编码、名称、备注搜索',
    textDetailTitle: '详细筛选',
    statusSection: '状态',
    sortSection: '排序',
    sortField: '排序字段',
    sortDir: '排序方向',
  },
  status: {
    all: '全部',
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  sort: {
    ngayTao: '创建日期',
    ma: '分组编码',
    tenNhom: '分组名称',
  },
  filters: {
    groupTreeSection: '客户分组',
    treeAll: '全部分组',
    treeSearch: '搜索客户分组',
  },
  fields: {
    code: '分组编码',
    name: '分组名称',
    note: '备注',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  titles: { add: '新增分组', edit: '编辑分组' },
  actions: {
    quickAdd: '快速添加客户分组',
  },
  messages: {
    noData: '暂无数据',
    loadError: '加载失败',
    createSuccess: '已创建',
    updateSuccess: '已更新',
    deleteSuccess: '已删除',
    notFound: '未找到',
    confirmDelete: '删除分组 «{name}»？',
    listSummary: '共 {count} 个客户分组',
    selectedCount: '已选：{count}',
    deleteSelected: '删除已选 ({count})',
    bulkDeleteConfirm: '删除已选的 {count} 个客户分组？（逐条调用删除 API。）',
    bulkDeleteSuccess: '已删除 {count} 个客户分组',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 个无法删除。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '未选择任何分组',
  },
  validation: {
    maRequired: '请输入组编码',
    maInvalid: '组编码只能包含字母、数字、连字符 (-) 或下划线 (_)，不能包含空格',
    tenRequired: '请输入组名称',
  },
  import: {
    description: '选择 Excel (.xlsx)：组编码、名称、备注、状态。',
    success: '客户分组导入成功',
    failed: '客户分组导入失败',
    noData: '文件中没有有效数据行',
  },
}
